<template>
    <div>
      <div style="overflow-x:auto" v-if="showBodyOnly">
          <table v-if="patients && patients.length">
              <tr class="header">
                  <th>Patient Name</th>
                  <th>Email</th>
                  <th v-if="patients[0].phoneNumber">Phone Number</th>
              </tr>
              <tbody>
                  <tr class="data" v-for="patient in patients" :key="patient.email" @click="goPatientDashboard(patient.uid)">
                          <td>{{ patient.name }} </td>
                          <td>{{ patient.email }} </td>
                          <td v-if="patient.phoneNumber">{{ patient.phoneNumber }}</td>
                          <td><div class="las la-angle-right"></div></td>
                  </tr>
              </tbody>
          </table>
          <div v-else>No Patients</div>
          <button v-if="!updatePending" @click="toAddPatient" class="btn add-patient"><i class="ion-plus-circled"></i> ADD PATIENT</button>
          <button v-else disabled @click="toAddPatient" class="btn add-patient"><i class="ion-plus-circled"></i> ADDING PATIENT</button>
          <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success" v-if="showSuccessMessage">
            <div class="iq-alert-text">Patient Added</div>
          </div>
      </div>
      <iq-card class="patients-list" v-else>
              <template v-slot:headerTitle>
                <h4 class="card-title">Patients</h4>
              </template>
              <template v-slot:headerAction>
                <div class="iq-search-bar">
                  <div class="searchbox">
                    <input type="text" class="text search-input" placeholder="Search" v-model="searchInput">
                    <span class="search-link"><i class="ri-search-line"></i></span>
                  </div>
                </div>
              </template>
              <template v-slot:default>
                <div style="overflow-x:auto">
                    <div v-if="patientsForEachPage && patientsForEachPage.length">
                        <table>
                            <tr class="header">
                                <th>Patient Name</th>
                                <th>Email</th>
                                <th v-if="patientsForEachPage[0].phoneNumber">Phone Number</th>
                            </tr>
                            <tbody>
                                <tr class="data" v-for="patient in patientsForEachPage" :key="patient.email" @click="goPatientDashboard(patient.uid)">
                                        <td>{{ patient.name }} </td>
                                        <td>{{ patient.email }} </td>
                                        <td v-if="patient.phoneNumber">{{ patient.phoneNumber }}</td>
                                        <td><div class="las la-angle-right"></div></td>
                                </tr>
                            </tbody>
                        </table>
                            <b-pagination :hide-goto-end-buttons="false" :per-page="perPage" limit="4"
                            v-model="currentPage" pills :total-rows="rows" size="sm" align="right" class="pagination"></b-pagination>
                             <div class="page-control mb-2">
                                Per Page
                                <select v-model="perPage" class="select">
                                 <option value=3>3</option>
                                  <option value=5>5</option>
                                  <option value=10>10</option>
                                  <option :value=filteredPatients.length>All</option>
                                </select>
                                Showing {{ start }} to {{ end }} of {{ total }}
                             </div>
                    </div>
                    <div v-else>No Patients</div>
                    <button v-if="!updatePending" @click="toAddPatient" class="btn add-patient"><i class="ion-plus-circled"></i> ADD PATIENT</button>
                    <button v-else disabled @click="toAddPatient" class="btn add-patient"><i class="ion-plus-circled"></i> ADDING PATIENT</button>
                    <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success" v-if="showSuccessMessage">
                      <div class="iq-alert-text">Patient Added</div>
                    </div>
                </div>
              </template>
            </iq-card>
    </div>
</template>

<script>
import { computed, ref, watch, watchEffect } from 'vue'
import { useRouter } from 'vue-router'
import { updateDocument } from '../services/useDocument'
import firebaseService from '../../firebase'
import { arrayUnion } from '@firebase/firestore'

export default {
  props: ['patients', 'onAddPage', 'showBodyOnly'],
  setup (props) {
    const firebaseDoctor = firebaseService.firebaseAuth.currentUser

    const router = useRouter()
    const { updatePending, handlelUpdate } = updateDocument('doctors', firebaseDoctor.uid)
    const showSuccessMessage = ref(false)

    const toAddPatient = async () => {
      if (props.onAddPage) {
        showSuccessMessage.value = false
        await handlelUpdate({ patients: arrayUnion(props.patients[0].uid) })
        showSuccessMessage.value = true
      } else {
        router.push({ name: 'patients.addPatient' })
      }
    }

    const goPatientDashboard = (uid) => {
      router.push({ name: 'patients.patientDashboard', params: { uid: uid } })
    }

    // control search patient
    const searchInput = ref(null)
    const sortPatientsByName = (a, b) => {
      const nameA = a.name.toUpperCase()
      const nameB = b.name.toUpperCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    }

    const filteredPatients = ref(null)
    const patientsForEachPage = ref(null)
    const total = ref(null)
    const currentPage = ref(1)
    const rows = computed(() => filteredPatients.value.length)
    const perPage = ref(5)

    watchEffect(() => {
      if (props.patients) {
        if (!searchInput.value || !searchInput.value.length) {
          filteredPatients.value = props.patients
        } else {
          currentPage.value = 1
          filteredPatients.value = props.patients.filter(patient => patient.name.toLowerCase().includes(searchInput.value.toLowerCase()) ||
        patient.email.toLowerCase().includes(searchInput.value.toLowerCase()))
        }

        filteredPatients.value = filteredPatients.value.sort(sortPatientsByName)
        total.value = filteredPatients.value.length

        const start = Number((currentPage.value - 1)) * Number(perPage.value)
        const end = start + Number(perPage.value)
        patientsForEachPage.value = filteredPatients.value.slice(start, end)
      }
    })

    const start = computed(() => {
      return Number((currentPage.value - 1)) * Number(perPage.value) + 1
    })

    const end = computed(() => {
      if (Number(start.value) + Number(perPage.value) - 1 > filteredPatients.value.length) {
        return filteredPatients.value.length
      }
      return Number(start.value) + Number(perPage.value) - 1
    })

    watch(perPage, () => {
      currentPage.value = 1
    })

    return {
      toAddPatient,
      updatePending,
      showSuccessMessage,
      goPatientDashboard,
      searchInput,
      filteredPatients,
      currentPage,
      rows,
      perPage,
      patientsForEachPage,
      start,
      end,
      total
    }
  }
}
</script>

<style scoped>
    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 1em;
    }
    .header {
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 0.03em;
    }
    .data {
        box-shadow: 0px 0px 9px 0px var(--box-shadow-color);
        margin-bottom: 20px;
    }

    td {
        padding: 15px 30px;
        margin-top: 15px;
    }

    td div {
        float: right;
        font-size: 15px;
    }

    th {
        padding-left: 30px;
    }

    .btn.add-patient {
        font-size: 15px;
        background-color: #b583bc;
        color: white;
        padding: 10px 15px;
        margin: 15px 15px 15px 0;
        float: right;
    }

    .pagination {
      padding: 10px 15px;
      display: inline-flex;
    }

    .page-control {
      margin: 10px 5px 0 15px;
      padding: 0 10px;
      display: inline-flex;
      float: right;
    }

    .select {
      margin-left: 10px;
      margin-right: 10px;
      padding: 0 10px;
    }

    div.alert {
        margin: 15px;
        float: left;
    }
</style>
